import React, { useState } from 'react'
import {FileTextOutlined} from '@ant-design/icons';
import {  Modal, Space } from 'antd';
import PackageDesc from './PackageDesc';
function PackageCheck(props) {
    const [open,setOpen] = useState(false)
    
    return (
        <>
            <a onClick={() => {setOpen(true)}}>
                <Space><FileTextOutlined/>{props.bbz_name}</Space>
            </a>
            <Modal
                open={open}
                okText="提交"
                cancelText="取消"
                onCancel={() => {
                    setOpen(false);
                }}
                onOk={() => {}}
                footer={null}
                width={1200}
            >            
                <PackageDesc
                     bbz_id={props.bbz_id}
                />        
            </Modal>
        </>
    )
}

export default PackageCheck